import React, {Component} from 'react';
import {t, Trans} from '@lingui/macro';
import {withI18n} from "@lingui/react";
import {connect} from 'react-redux';
import {Col, Row, Input, Form} from 'antd';
import _ from 'underscore';
import {Select, AutoComplete} from "../DataEntry";
import {Styled} from './style';
import BukkuTooltip from '../Tooltip';
import ContactActions from 'bukku/redux/Contact/actions';
import ListActions from 'bukku/redux/List/actions';
import {L} from "bukku/redux/List/reducer";
import {Type} from "bukku/redux/Transaction/helper";
// import { createListManager } from "bukku/redux/List/helper";
// import AutoComplete from '../AutoComplete';
// import { AutoComplete } from '../DataEntry';

const { Option } = Select;

const {
    readContact,
    setBillingContactPersonId,
    setShippingContactPersonId,
} = ContactActions;

const {
    resetLists,
} = ListActions;

const getDefaultDetails = cp => {
    if (cp.is_default_billing && cp.is_default_shipping)
        return <Trans>Default Billing & Shipping</Trans>;

    if (cp.is_default_billing)
        return <Trans>Default Billing</Trans>;

    if (cp.is_default_shipping)
        return <Trans>Default Shipping</Trans>;

    return null;
};

export const getDisplayName = cp => {
    let displayName;
    if (cp.first_name) {
        if (cp.last_name)
            displayName = `${cp.first_name} ${cp.last_name}`;

        else
            displayName = cp.first_name;
    }
    else if (cp.last_name) {
        displayName = cp.last_name;
    }

    return displayName;
};

const ContactSelectOption = React.memo(props => {
    const { item } = props;

    return (
        <Styled>
            <Row className="option-row">
                <Col span={16} className="name-col">
                    <BukkuTooltip>{getDisplayName(item)}</BukkuTooltip>
                </Col>
                <Col span={8} className="detail-col" align="right">
                    {getDefaultDetails(item)}
                </Col>
            </Row>

        </Styled>
    );
});

class ContactPersonInput extends Component {
    // listManager = createListManager([L.contact_persons]);

    // On contactId change:
    // new.js (normal and instructions): CP will be read in useContact.js
    // new.js (Autosave): CP will be read in processRestoreAutosaveForm.js
    // view.js: CP will be read in initTransaction/saga.js
    componentDidUpdate() {
        // const {
        //     contactId,
        // } = this.props;
        // if (contactId && prevProps.contactId !== contactId) {
        //     let contactIdToUse = contactId;

        //     // Recurring instructions, contact id is like contact_${id}, eg contact_3
        //     if (typeof contactId === 'string') {
        //         contactIdToUse =
        //             contactId.includes('contact_') ?
        //                 parseInt(contactId?.toString().replace(/^contact_/, ""), 10) :
        //                 null;
        //     }
        //     this.listManager.readLists({ contact_persons: { contact_id: contactIdToUse } });
        // }
    }

    componentWillUnmount() {
        const {
            resetLists,
            setBillingContactPersonId,
            setShippingContactPersonId,
        } = this.props;

        resetLists?.([L.contact_persons]);
        setBillingContactPersonId(null);
        setShippingContactPersonId(null);
    }

    renderOption = item => (
        <Option
            value={getDisplayName(item)}
            key={item.id}
            item={item}
        >
            <ContactSelectOption item={item} />
        </Option>
    );

    onSelect = (value, option) => {
        const {name, setBillingContactPersonId, setShippingContactPersonId} = this.props;

        // upon selecting an option, set the cp id
        if (name === 'billing_contact_person_id_or_name')
            setBillingContactPersonId(option.item.id);
        else
            setShippingContactPersonId(option.item.id);
    };

    // onChange using text input
    onChange = (value, option) => {
        const {name, setBillingContactPersonId, setShippingContactPersonId} = this.props;

        // if using text input, and text matches an option, set the cp's option id
        if (!_.isEmpty(option)) {
            if (name === 'billing_contact_person_id_or_name')
                setBillingContactPersonId(option.item.id);
            else
                setShippingContactPersonId(option.item.id);
        }
        // else if using text input, but doesn't match an option/not selecting an option, set the cp id as null
        else if (name === 'billing_contact_person_id_or_name') {
            setBillingContactPersonId(null);
        }
        else {
            setShippingContactPersonId(null);
        }
    };

    render() {
        const {
            // From parent
            name,
            label,
            className,
            contactPersons,
            disabled,
            transaction,
            readOnly,
        } = this.props;

        return (
            <Form.Item
                name={name}
                label={label}
                validateTrigger="onBlur"
                className={className}
                // readOnly={readOnly}
            >
                <AutoComplete
                    disabled={disabled}
                    filterOption={false}
                    onSelect={this.onSelect}
                    onChange={this.onChange}
                    allowClear
                    readOnly={readOnly}
                >
                    { name !== 'shipping_contact_person_id_or_name' || (
                        transaction.type !== Type.purchase_bill &&
                        transaction.type !== Type.purchase_credit_note &&
                        transaction.type !== Type.purchase_goods_received_note &&
                        transaction.type !== Type.purchase_order
                    ) ? contactPersons.map(this.renderOption) : []}
                </AutoComplete>
            </Form.Item>

        );
    }
}

export default connect(state => ({
    contacts: state.List.contacts,
    contactPersons: state.List.contactPersons,
    contactId: state.Transaction.contactId,
    billingContactPersonId: state.Contact.billingContactPersonId,
    shippingContactPersonId: state.Contact.shippingContactPersonId,
    transaction: state.Transaction.transaction,
}), {
    //
    readContact,
    resetLists,
    setBillingContactPersonId,
    setShippingContactPersonId,
})(withI18n()(ContactPersonInput));
